// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__7KCUI","scrollText":"Banner_scrollText__AQ+ax","containerItem":"Banner_containerItem__4O80x","crossBox":"Banner_crossBox__2S5PT"};